export class TokenReadError extends Error {}
